<script>
    import ViewReward from "./ViewReward.svelte";

    export let rewards;
    export let type;
    rewards = rewards ?? [];
</script>

<div class="rewards">
    {#if rewards.length == 0}
        <span>Keine Belohnungen eingetragen</span>
    {:else}
        {#each rewards as reward, i}
            <ViewReward bind:reward={reward}/>
            {#if i < rewards.length - 1}
            {type=="all"?"und":type=="choice"?"oder":";"}<br>
            {/if}
        {/each}
    {/if}
</div>

<style>
    .rewards {
        /* display: flex;
        flex-wrap: wrap; */
        gap: 0.5rem;
    }
</style>